<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Subsidio' : 'Agregar Subsidio' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P143B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P143B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P143F0001">
    <div class="form-row">
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable Id</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P143K0001" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P143K0002" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Porcentaje</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P143K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Importe</label>
        <input class="form-control" placeholder="0.2" formControlName="valorFijo" type="number" appPermissionControl="P143K0004" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Impuesto</label>
        <input class="form-control" placeholder="1" formControlName="porcentaje" type="number" appPermissionControl="P143K0005" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Contabilidad</label>
        <select class="form-control" formControlName="formula" appPermissionControl="P143K0006">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of accounting" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
